module.exports = __webpack_public_path__ + "static/img/警示.816af07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dialog/警示.png
// module id = 117
// module chunks = 126 170 363 364